export default "__VITE_ASSET__C_k10vRf__"